/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NotificationMessage,
  PushToken,
  PushTokenSaveRequest,
} from '../models/index';
import {
    NotificationMessageFromJSON,
    NotificationMessageToJSON,
    PushTokenFromJSON,
    PushTokenToJSON,
    PushTokenSaveRequestFromJSON,
    PushTokenSaveRequestToJSON,
} from '../models/index';

export interface GetNotificationsRequest {
    programmeId?: string;
    language?: string;
}

export interface GetPushTokenRequest {
    deviceId?: string;
    appId?: string;
}

export interface MarkNotificationsAsReadRequest {
    requestBody?: Array<string>;
}

export interface SavePushTokenRequest {
    deviceId?: string;
    appId?: string;
    pushTokenSaveRequest?: PushTokenSaveRequest;
}

/**
 * 
 */
export class NotificationCenterApi extends runtime.BaseAPI {

    /**
     */
    async getNotificationsRaw(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NotificationMessage>>> {
        const queryParameters: any = {};

        if (requestParameters.programmeId !== undefined) {
            queryParameters['programmeId'] = requestParameters.programmeId;
        }

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/NotificationCenter/GetNotifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NotificationMessageFromJSON));
    }

    /**
     */
    async getNotifications(requestParameters: GetNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NotificationMessage>> {
        const response = await this.getNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPushTokenRaw(requestParameters: GetPushTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushToken>> {
        const queryParameters: any = {};

        if (requestParameters.deviceId !== undefined) {
            queryParameters['deviceId'] = requestParameters.deviceId;
        }

        if (requestParameters.appId !== undefined) {
            queryParameters['appId'] = requestParameters.appId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/NotificationCenter/GetPushToken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushTokenFromJSON(jsonValue));
    }

    /**
     */
    async getPushToken(requestParameters: GetPushTokenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushToken> {
        const response = await this.getPushTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async markNotificationsAsReadRaw(requestParameters: MarkNotificationsAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/NotificationCenter/MarkNotificationsAsRead`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markNotificationsAsRead(requestParameters: MarkNotificationsAsReadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markNotificationsAsReadRaw(requestParameters, initOverrides);
    }

    /**
     */
    async savePushTokenRaw(requestParameters: SavePushTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushToken>> {
        const queryParameters: any = {};

        if (requestParameters.deviceId !== undefined) {
            queryParameters['deviceId'] = requestParameters.deviceId;
        }

        if (requestParameters.appId !== undefined) {
            queryParameters['appId'] = requestParameters.appId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/NotificationCenter/SavePushToken`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PushTokenSaveRequestToJSON(requestParameters.pushTokenSaveRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushTokenFromJSON(jsonValue));
    }

    /**
     */
    async savePushToken(requestParameters: SavePushTokenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushToken> {
        const response = await this.savePushTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
